const backgroundTasks = (state = {
    tasks: []
}, action) => {
    switch (action.type) {
        case 'BACKGROUND_TASK_START_SOCKET':
            return {
                tasks: [...state.tasks, action.payload.task]
            };

        case 'BACKGROUND_TASK_PROGRESS_SOCKET':
            if (state.tasks.some(task => task.id === action.payload.task.id)) {
                return {
                    tasks: [...state.tasks].map(task => {
                        if (task.id === action.payload.task.id) {
                            return action.payload.task;
                        }

                        return task;
                    })
                };
            }

            return {
                tasks: [...state.tasks, action.payload.task]
            };

        case 'BACKGROUND_TASK_ERROR_SOCKET':
            if (state.tasks.some(task => task.id === action.payload.task.id)) {
                return {
                    tasks: [...state.tasks].map(task => {
                        if (task.id === action.payload.task.id) {
                            return {
                                ...task,
                                error: true
                            };
                        }

                        return task;
                    })
                };
            }

        case 'BACKGROUND_TASK_FINISH_SOCKET':
            return {
                tasks: state.tasks.filter(task => task.id !== action.payload.task.id)
            };

        case 'BACKGROUND_TASK_REMOVE':
            return {
                tasks: state.tasks.filter(task => task.id !== action.payload.taskId)
            };

        default:
            return state;
    }
}

export default backgroundTasks;
